<div class="post-details-view-container" *ngIf="postObject" fxLayout="column" fxLayoutGap="15px" >

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + postObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="postObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).asf_360.write " (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
    <button [disabled]="!(userPermissions | async).asf_360.create " (click)="copyPost()" mat-stroked-button color="primary"><mat-icon>content_copy</mat-icon> <span> Kopiuj post</span></button>
    <button *ngIf="(userPermissions | async).asf_360.admin_root || ( postObject.createdBy.uuid === profile.userId  && (userPermissions | async).asf_360.delete)" [disabled]="!(userPermissions | async).asf_360.admin_root && postObject.createdBy.uuid !== profile.userId" (click)="delete()" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>
    <button *ngIf="postObject.competitionCta"  [disabled]="!(userPermissions | async)?.asf_360.admin_root"
             mat-stroked-button (click)="downloadReport()">
      <mat-icon>download</mat-icon> Pobierz raport</button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="60" fxFlex.lt-md="100" fxLayoutGap="15px">
        <mat-card>

          <div fxLayout="row">
            <h3>Dane</h3>
          </div>
          <div fxLayout="row" fxLayoutGap="15px">

            <div fxLayout="row" >
              <app-detail fxFlex="100" header="Nazwa postu" [value]="postObject.postName"></app-detail>
            </div>

          </div>

          <div fxLayout="row">
            <h5>  Treść postu krótka</h5>
          </div>
          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="100" [innerHTML]="postObject.shortContent"> </div>

          </div>

          <div fxLayout="row" fxLayoutGap="15px" *ngIf="postObject.attachments.length > 0  && haveShortAttachment">
            <div  fxFlex="100">
              <div fxLayout="row" fxLayoutGap="15px" >
                <div fxFlex="100" fxLayout="row">
                  <app-detail header="Post krótki">
                    <mat-chip-list>
                      <ng-container *ngFor="let attachment of postObject.attachments">
                        <mat-chip selected  *ngIf='attachment.type.key==="short"' >

                                                    <img
                                                    matChipAvatar
                                                    src="{{src.production}}/filePublic/{{attachment.fileLocation}}"
                                                    alt="Photo of a Shiba Inu"
                                                    />

                          {{attachment.fileName}}


                          <button mat-icon-button color="warn"  [disabled]="!(userPermissions | async).asf_360.delete"
                                  (click)="deleteAttachment(attachment)">
                            <mat-icon>cancel</mat-icon>
                          </button>

                        </mat-chip>
                      </ng-container>
                    </mat-chip-list>
                  </app-detail>
                </div>
              </div>
            </div>
          </div>
        </mat-card>

        <mat-card>

          <div fxLayout="row" fxLayoutGap="15px">
            <h3>CTA</h3>
          </div>
            <div fxLayout="row" fxLayoutGap="15px">

              <app-detail-bool fxFlex="100" header="Konkursowe CTA" [value]="postObject.competitionCta"></app-detail-bool>

            </div>

          <div  fxLayout="row" fxLayoutGap="15px">
            <app-detail fxFlex="100" header="Nagłówek CTA" [value]="postObject.ctaHeadline"></app-detail>
          </div>


          <div  fxLayout="row" fxLayoutGap="15px">
            <app-detail fxFlex="100" header="Tekst CTA" [value]="postObject.ctaText"></app-detail>
          </div>

          <div  fxLayout="row" fxLayoutGap="15px"  *ngIf="!postObject.competitionCta">
            <app-detail fxFlex="100" header="Link CTA"  [value]="postObject.ctaLink"></app-detail>
          </div>

          <div  fxLayout="row" fxLayoutGap="15px"  *ngIf="postObject.competitionCta">
            <app-detail fxFlex="100" header="Przycisk CTA po kliknięciu"  [value]="postObject.ctaLink"></app-detail>
          </div>

          <div  fxLayout="row" fxLayoutGap="15px">
            <app-detail fxFlex="90" header="Przycisk CTA" [value]="postObject.ctaButton"></app-detail>
          </div>

          <div  fxLayout="row" fxLayoutGap="15px">
            <app-detail fxFlex="90" header="Aktywny do" [value]="postObject.ctaEndDate | date:'y-MM-dd'"></app-detail>
          </div>

          <div  fxLayout="row" fxLayoutGap="15px">
            <app-detail fxFlex="90" header="Nagłówek CTA po wygaśnięciu" [value]="postObject.ctaExpiredText"></app-detail>
          </div>
      </mat-card>


      <mat-card>
        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <h3>Treść postu długa</h3>
          </div>
        </div>

        <div fxLayout="column" fxFlex.lt-md="100" fxLayoutGap="15px">
          <div fxFlex="100" fxLayoutGap="15px">
            <ng-container *ngFor="let postDetails of postObject.postDetails; let i = index">
              <HR SIZE=1 >
              <div fxLayout="row" fxLayoutGap="15px" >
                <div *ngIf="postDetails.postDetailType === 'TEXT'" fxFlex="100" fxLayoutGap="15px">
                  <div  fxLayout="column"   fxFlex="100" >

                        <h3>{{ i + 1 }}. Pole tekstowe</h3>

                    <div  fxLayout="row"  fxFlex="100">
                      <div style=" max-height:300px; overflow: auto; white-space: normal; word-wrap: break-word;" fxFlex="94"  [innerHTML]="postDetails.postDetailText"></div>
                    </div>
                  </div >
                </div>

                <div *ngIf="postDetails.postDetailType === 'MOVIE'" fxFlex="100" fxLayoutGap="15px">
                  <div  fxLayout="column"   fxFlex="100" >

                    <h3>{{ i + 1 }}. Film</h3>

                    <div  fxLayout="row"  fxFlex="100">
                      <app-detail fxFlex="100" header="Link " [value]="postDetails.postDetailMovieLink"></app-detail>
                    </div>
                  </div >
                </div>

                <div *ngIf="postDetails.postDetailType === 'ATTACHMENT' " fxFlex="100" fxLayoutGap="15px">

                  <div  fxLayout="column"   fxFlex="100" >
                    <div  fxLayout="row"   fxFlex="100" >
                      <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                        <h3>{{ i + 1 }}. Załacznik</h3>
                      </div>
                    </div>
                    <div  fxLayout="row"  fxFlex="90">
                      <mat-chip-list>
                        <ng-container>
                          <mat-chip>
                            {{postDetails.postDetailFilename}}

                            <button matChipRemove  [disabled]="!(userPermissions | async).asf_360.read"
                                    (click)="downloadAttachmentFile(postDetails.postDetailFileLocation, postDetails.postDetailFilename)">
                              <mat-icon>download</mat-icon>
                            </button>
                          </mat-chip>
                        </ng-container>
                      </mat-chip-list>
                    </div>
                  </div >

                </div>
                <div *ngIf=" postDetails.postDetailType === 'GRAPHICS'" fxFlex="100" fxLayoutGap="15px">
                  <div  fxLayout="column"   fxFlex="100" >
                    <div  fxLayout="row"   fxFlex="100" >
                      <div   fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                        <h3>{{ i + 1 }}. Grafika</h3>
                      </div>
                    </div>
                    <div  fxLayout="row"  fxFlex="90">
                      <img class=" avatar-360" src="/rest/crm/asf360/file/{{postDetails.postDetailFileLocation}}/image/{{postDetails.postDetailFilename}}" alt="Zdjęcie"/>
                    </div>
                    <div fxLayout="row" fxLayoutGap="15px">
                      <app-detail fxFlex="100" header="Link CTA" [value]="postDetails.postDetailCtaLink"></app-detail>
                    </div>
                  </div >
                </div>

                <div *ngIf="postDetails.postDetailType === 'CTA'" fxFlex="100" fxLayoutGap="15px">
                  <div  fxLayout="column"   fxFlex="100" >
                    <div  fxLayout="row"   fxFlex="100" >
                      <div  fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                        <h3>{{ i + 1 }}. CTA</h3>
                      </div>
                    </div>
                    <div  fxLayout="row"  fxFlex="100">
                      <div  fxLayout="column"   fxFlex="100" >
                        <div fxLayout="row" fxLayoutGap="15px">
                          <app-detail fxFlex="50" header="Nagłówek CTA" [value]="postDetails.postDetailCtaHeadline"></app-detail>
                          <app-detail fxFlex="50" header="Tekst CTA" [value]="postDetails.postDetailCtaText"></app-detail>
                        </div>
                        <div fxLayout="row" fxLayoutGap="15px">
                          <app-detail fxFlex="50" header="Link CTA" [value]="postDetails.postDetailCtaLink"></app-detail>
                          <app-detail fxFlex="50" header="Przycisk CTA" [value]="postDetails.postDetailCtaButton"></app-detail>
                        </div>

                        </div>
                      </div>
                    </div>
                  </div >
                <div *ngIf="postDetails.postDetailType === 'TABLE'" fxFlex="100" fxLayoutGap="15px">
                  <div  fxLayout="column"   fxFlex="100" >

                    <h3>{{ i + 1 }}. Tabela</h3>

                    <div  fxLayout="row"  fxFlex="100">
                      <div fxLayout="column"  style=" max-height:300px; overflow: auto; white-space: normal; word-wrap: break-word;" fxFlex="{{postDetails.postTableColumn === 3 ? 33: 50}}"  [innerHTML]="postDetails.postDetailText"></div>

                      <div fxLayout="column"  style=" max-height:300px; overflow: auto; white-space: normal; word-wrap: break-word;" fxFlex="{{postDetails.postTableColumn === 3 ? 33: 50}}"  [innerHTML]="postDetails.postDetailTextSecond"></div>

                      <div *ngIf="postDetails.postTableColumn === 3 " fxLayout="column"  style=" max-height:300px; overflow: auto; white-space: normal; word-wrap: break-word;" fxFlex="33"  [innerHTML]="postDetails.postDetailTextThird"></div>
                    </div>
                  </div >
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </mat-card>


    </div>


    <div fxLayout="column" fxFlex="40" fxFlex.lt-md="100" fxLayoutGap="15px">

      <mat-card>

        <div fxLayout="row" fxLayoutGap="15px">
          <h3>Szczegóły postu</h3>
        </div>

        <div  fxLayout="row" fxLayoutGap="15px">
          <app-detail   fxFlex="100" header="Dział publikujący" [value]="postObject.publishingDepartment.name"></app-detail>
        </div>

        <div  fxLayout="row" fxLayoutGap="15px">
          <app-detail fxFlex="100" header="Typ postu" [value]="postObject.type.name"></app-detail>
        </div>


      <div *ngIf="postObject.tags.length > 2">

        <div fxLayout="row" fxLayoutGap="15px">
          <h3>Tagi</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" >
          <div fxFlex="100">
            <app-detail header="">
              <mat-chip-list>
                <ng-container *ngFor="let tag of postObject.tags">
                  <mat-chip *ngIf="tag.id!==postObject.type.id && tag.id!==postObject.publishingDepartment.id " color="accent" selected>{{tag.name}}</mat-chip>
                </ng-container>
              </mat-chip-list>
            </app-detail>
          </div>
        </div>

      </div>
      </mat-card>


      <mat-card *ngIf="haveAttachmentAttachment">

        <div fxLayout="row" fxLayoutGap="15px">
          <h3>Załaczniki</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div  fxFlex="100">
            <div fxLayout="row" fxLayoutGap="15px" *ngIf="postObject.attachments.length > 0">
              <div fxFlex="100" fxLayout="row">
                <app-detail header="Załączniki">
                  <mat-chip-list>
                    <ng-container *ngFor="let attachment of postObject.attachments">
                      <mat-chip selected  *ngIf='attachment.type.key==="attachment"'>
                        {{attachment.fileName}}

                        <button matChipRemove  [disabled]="!(userPermissions | async).asf_360.read"
                                (click)="downloadAttachment(attachment)">
                          <mat-icon>download</mat-icon>
                        </button>

                        <button mat-icon-button color="warn"  [disabled]="!(userPermissions | async).asf_360.delete"
                                (click)="deleteAttachment(attachment)">
                          <mat-icon>cancel</mat-icon>
                        </button>

                      </mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>
          </div>
        </div>

      </mat-card>

      <mat-card>

        <div fxLayout="row" fxLayoutGap="15px">
          <h3>Data Publikacji</h3>
        </div>

        <div  fxLayout="row" fxLayoutGap="15px">
          <app-detail fxFlex="100" header="Data publikacji" [value]="postObject.startAt | date:'y-MM-dd HH:mm '"></app-detail>
        </div>


        <div  fxLayout="row" fxLayoutGap="15px">
          <app-detail fxFlex="100" header="Data wygaśnięcia" [value]="postObject?.endAt | date:'y-MM-dd  HH:mm '"></app-detail>

        </div>
      </mat-card>

      <mat-card>

        <div fxLayout="row">
          <h3>Użytkownicy</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <ng-container *ngFor="let users of postObject.users; let i = index">
              <div fxLayout="row" fxLayoutGap="15px">
                <span fxFlex="5">{{i+1}}.</span>
                <app-detail fxFlex="47" header="Imie i nazwisko">{{users.usersName}}</app-detail>
                <app-detail fxFlex="47" header="Stanowisko">{{users.usersPosition}}</app-detail>

              </div>
              <div fxLayout="row" fxLayoutGap="15px">
                <span fxFlex="5"></span>
                <app-detail fxFlex="47" header="Numer telefonu">{{users.usersPhone}}</app-detail>
                <app-detail fxFlex="47" header="Email">{{users.usersEmail}}</app-detail>

              </div>
            </ng-container>
          </div>
        </div>

      </mat-card>

      <mat-card>
        <div fxLayout="row">
          <h3>Uprawnienia</h3>
        </div>
        <div fxLayout="column"  fxLayoutGap="15px">
          <mat-card>
            <div fxLayout="row">
              <h4 class="structure-title">Grupy uprawnień</h4>
            </div>
            <div fxLayout="row">
              <p class="structure-description">Post będzie udostępniony tylko dla wskazanej grupy użytkowników.</p>
            </div>
          <div fxLayout="row" fxLayoutGap="15px">
            <div  fxFlex="100">
              <div fxLayout="row" fxLayoutGap="15px" >
                <div fxFlex="100">
                  <app-detail header="Grupy uprawnień">
                    <mat-chip-list>
                      <ng-container *ngFor="let tag of permissionTag">
                        <mat-chip selected>{{tag.name}}</mat-chip>
                      </ng-container>
                    </mat-chip-list>
                  </app-detail>
                </div>
              </div>
            </div>
          </div>
          </mat-card>

          <mat-card >

            <div fxLayout="row">
              <h4 class="structure-title">Struktura</h4>
            </div>
            <div fxLayout="row">
              <p class="structure-description">Post będzie udostępniony dla użytkowników wskazanych struktur.</p>
            </div>


        <div fxLayout="row" fxLayoutGap="15px">
          <div  fxFlex="50">
            <app-detail-bool fxFlex="100" header="ASF Premium" [value]="postObject.permissionAsfPremium"></app-detail-bool>
          </div>

          <div  fxFlex="50">
            <app-detail-bool fxFlex="100" header="Multisfera" [value]="postObject.permissionMultisfera"></app-detail-bool>
          </div>
        </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div  fxFlex="50">
                <app-detail-bool fxFlex="100" header="ASF" [value]="postObject.permissionAsf"></app-detail-bool>
              </div>
              <div  fxFlex="50">
                <app-detail-bool fxFlex="100" header="Multiagencja Profitowi" [value]="postObject.permissionMultiAgencyProfit"></app-detail-bool>
              </div>

            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div  fxFlex="50">
              </div>
              <div  fxFlex="50">
                <app-detail-bool fxFlex="100" header="Pracownicy" [value]="postObject.permissionEmployee"></app-detail-bool>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div  fxFlex="50">
                <br>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div  fxFlex="50">
                <app-detail-bool fxFlex="100" header="Partner" [value]="postObject.permissionPartner"></app-detail-bool>
              </div>
              <div  fxFlex="50">
                <app-detail-bool fxFlex="100" header="OFWCA" [value]="postObject.permissionOfwca"></app-detail-bool>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div  fxFlex="50">
                <app-detail-bool fxFlex="100" header="Aktualności produktowe" [value]="postObject.permissionPartnerCompetition"></app-detail-bool>
              </div>
              <div  fxFlex="50">
                <app-detail-bool fxFlex="100" header="Aktualności marketingowe" [value]="postObject.permissionOfwcaCompetition"></app-detail-bool>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div  fxFlex="50">
              </div>
              <div  fxFlex="50">
                <app-detail-bool fxFlex="100" header="Aktualności produktowe" [value]="postObject.permissionOfwcaProduct"></app-detail-bool>
              </div>
            </div>
          </mat-card>
          <mat-card >
            <div fxLayout="row">
              <h4 class="structure-title">Pozostałe</h4>
            </div>
            <div fxLayout="row">
              <p class="structure-description">Dodatkowe parametry po których można ograniczyć odbiorców posta.</p>
            </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div  fxFlex="100">
            <div fxLayout="row" fxLayoutGap="15px" >
              <div fxFlex="100">
                <app-detail header="Statusy szkoleń IDD">
                  <mat-chip-list>
                    <ng-container *ngFor="let status of permissionIddTrainingStatus">
                      <mat-chip selected>{{status.name}}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div  fxFlex="100">
            <app-detail-bool fxFlex="100" header="Działy" [value]="postObject.permissionDepartment"></app-detail-bool>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" *ngIf="postObject.permissionDepartment">
          <div  fxFlex="100">
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail >
                  <mat-chip-list>
                    <ng-container *ngFor="let pd of permissionDepartment">
                      <mat-chip  selected>{{pd.name}}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" >
          <div  fxFlex="100">
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Regionalny">
                  <mat-chip-list>
                    <ng-container *ngFor="let regional of permissionRegional">
                      <mat-chip  selected>{{regional.fullName}}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div  fxFlex="100">
            <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center">
              <div fxFlex="50">
                <app-detail header="Typ umowy">
                  <mat-chip-list>
                    <ng-container *ngFor="let contractType of permissionContractType">
                      <mat-chip  selected>{{contractType.name}}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
              <div  fxFlex="50">
                <app-detail-bool fxFlex="100" header="Typ umowy parametr AND" [value]="postObject.permissionContractAnd"></app-detail-bool>
              </div>
            </div>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div  fxFlex="100">
            <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center">
              <div fxFlex="50">
                <app-detail header=" Tagi Partnera">
                  <mat-chip-list>
                    <ng-container *ngFor="let tagPartner of permissionTagPartner">
                      <mat-chip  selected>{{tagPartner.name}}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
              <div  fxFlex="50">
                <app-detail-bool fxFlex="100" header="Tagi Partnera parametr AND" [value]="postObject.permissionTagPartnerAnd"></app-detail-bool>
              </div>
            </div>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px">
          <div  fxFlex="100">
            <app-detail-bool fxFlex="100" header="Rejestracje" [value]="postObject.permissionRegistration"></app-detail-bool>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" *ngIf="postObject.permissionRegistration">
          <div  fxFlex="100">
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail >
                  <mat-chip-list>
                    <ng-container *ngFor="let ic of permissionRegistration">
                      <mat-chip  selected>{{ic.name}}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>
          </div>
        </div>
          </mat-card>
        </div>
      </mat-card>

    </div>
  </div>
</div>
